// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NetworkProvider } from './contexts/NetworkContext';
import { WalletProvider } from './contexts/WalletContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { TransactionProvider } from './contexts/TransactionContext';
import { AuthProvider } from './contexts/AuthContext';
import { DAppProvider } from './contexts/DAppContext'; 
import TranslationProvider from './components/Translation/TranslationProvider';
import { handleTelegramParams, isTelegramWebApp } from './utils/deepLinkUtils';

// Import i18n without using it directly - this ensures it's initialized
import './i18n';

// Process Telegram parameters before React initializes
const prepareTelegramDeepLinks = () => {
  if (isTelegramWebApp()) {
    const webApp = window.Telegram && window.Telegram.WebApp;
    if (webApp && webApp.initDataUnsafe && webApp.initDataUnsafe.start_param) {
      // If we have a start parameter, process it
      const startParam = webApp.initDataUnsafe.start_param;
      console.log("Early processing of Telegram startParam:", startParam);
      handleTelegramParams(startParam);
    }
  }
};

// Call preprocessing function before React render
prepareTelegramDeepLinks();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TranslationProvider>
      <NetworkProvider>
        <AuthProvider>
          <WalletProvider>
            <SettingsProvider>
              <TransactionProvider>
                <DAppProvider>
                  <App />
                </DAppProvider>
              </TransactionProvider>
            </SettingsProvider>
          </WalletProvider>
        </AuthProvider>
      </NetworkProvider>
    </TranslationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();